import React from 'react';
import config from 'react-global-configuration';

import Card from '../../../../components/Molecules/Card';
import './style.scss';

const NodeArticleTeaser = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'summary']);
  const image = entity.getIn(['field_media_image', 0, 'styles', 'paragraph_image'], null);
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');
  const language = config.get('DEFAULT_LANGUAGE');
  const type = entity.getIn(['type', 0, 'target_id'], null);
  const link = entity.getIn(['paths', language], entity.get('paths').first());
  const subType = entity.getIn(['field_article_type', 0, 'entity', 'name', 0, 'value'], entity.getIn(['entity', 'type', 0, 'target_id']));
  const changed = entity.getIn(['field_changed', 0, 'value'], entity.getIn(['changed', 0, 'value'], null));
  return <Card title={title} created={changed ? ((new Date(changed)).getTime() / 1000) : null} image={image} alt={imageAlt} body={body} type={type} subType={subType} link={link} />;
};

export default NodeArticleTeaser;
